// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.92.0-next',
  revision: '08bb017fe',
  branch: 'next',
  date: 'Fri, 16 Oct 2026 16:25:03 GMT'
};